var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle54ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M16.498 15.715h31a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-31a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M36.794 3.989a2.5 2.5 0 0 1 2.49-2.274h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726H38.74a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M38.74 2.715c-.687 0-1.315.388-1.622 1.002l-.222.445a1 1 0 1 1-1.79-.894l.223-.446A3.812 3.812 0 0 1 38.74.715h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445a1.812 1.812 0 0 0-1.621-1.002h-6.524Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.208 45.441a2.5 2.5 0 0 1-2.49 2.274h-5.433a2.5 2.5 0 0 1-2.49-2.274l-.546-6a2.5 2.5 0 0 1 2.49-2.726h6.525a2.5 2.5 0 0 1 2.49 2.726l-.546 6Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M35.263 46.715c.687 0 1.314-.388 1.621-1.002l.223-.445a1 1 0 0 1 1.789.894l-.223.445a3.812 3.812 0 0 1-3.41 2.108H28.74a3.812 3.812 0 0 1-3.41-2.108l-.223-.445a1 1 0 0 1 1.789-.894l.222.445a1.812 1.812 0 0 0 1.622 1.002h6.523Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.794 3.989a2.5 2.5 0 0 1 2.49-2.274h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M18.74 2.715c-.687 0-1.315.388-1.622 1.002l-.222.445a1 1 0 1 1-1.79-.894l.223-.446A3.812 3.812 0 0 1 18.74.715h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445a1.812 1.812 0 0 0-1.621-1.002h-6.524Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.275 29.922A2.5 2.5 0 0 1 1 27.432v-5.434a2.5 2.5 0 0 1 2.274-2.49l6-.545A2.5 2.5 0 0 1 12 21.453v6.524a2.5 2.5 0 0 1-2.726 2.49l-6-.545Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M2.001 27.976c0 .687.388 1.315 1.002 1.622l.445.222a1 1 0 0 1-.894 1.79l-.446-.224a3.812 3.812 0 0 1-2.107-3.41v-6.523c0-1.444.816-2.764 2.107-3.41l.446-.223a1 1 0 1 1 .894 1.79l-.445.222A1.812 1.812 0 0 0 2 21.452v6.524Z",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M60.727 19.508a2.5 2.5 0 0 1 2.274 2.49v5.434a2.5 2.5 0 0 1-2.274 2.49l-6 .545a2.5 2.5 0 0 1-2.726-2.49v-6.525a2.5 2.5 0 0 1 2.726-2.49l6 .546Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M62.001 21.453c0-.686-.388-1.314-1.002-1.62l-.445-.223a1 1 0 0 1 .894-1.79l.446.223A3.812 3.812 0 0 1 64 21.453v6.524a3.812 3.812 0 0 1-2.108 3.41l-.445.223a1 1 0 1 1-.894-1.79l.445-.222a1.812 1.812 0 0 0 1.002-1.621v-6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle54ASelected.viewBox = '0 0 64 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle54ASelected);
export default ForwardRef;